import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";
import { DialogService } from "primeng/dynamicdialog";
import { CreateEditFieldValueComponent } from "../components/create-edit-field-value/create-edit-field-value.component";

@Component({
	selector: 'cv-select-chips',
	templateUrl: './select-chips.component.html',
	styleUrls: [ './select-chips.component.scss' ]
})
export class SelectChipsComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	activeSpinner: boolean;
	searchValue: string;
	options: any;
	data: any = [];

	constructor(private dialogService: DialogService) {
		this.activeSpinner = false;
		this.options = [];
	}

	ngOnInit(): void {
		this.data = this.control.value || [];
	}

	/**
	 * event to remove item from list
	 * @param index
	 */
	removeItem(index: number): void {
		this.data.splice(index, 1);
		this.control.setValue(this.data);
	}

	/**
	 * event to search option in input search field
	 * @param $event
	 */
	searchOptions($event): void {
		this.options = [ ...this.options ];
	}

	/**
	 * event to add selected option in the list
	 * @param $event
	 */
	addSelectedOption($event: any): void {
		this.data.push($event.label);
		this.control.setValue(this.data);
		this.searchValue = '';
	}

	/**
	 * event to create new option in the endpoint
	 */
	addNewOption(): void {
		this.dialogService.open(CreateEditFieldValueComponent, {
			header: 'Add ' + this.field.DisplayText,
			width: '21.3rem',
			closeOnEscape: false,
			dismissableMask: false,
			styleClass: 'add-config-type-modal',
			draggable: false,
			data: {
				isDate : this.field.UIOptions?.SelectChips?.isDate,
				childForm: this.field.UIOptions.SelectChips.childForm,
			}
		}).onClose.subscribe((result) => {
			if (result && result.data) {
				this.data.push(result.data.label);
				this.control.setValue(this.data);
			}
		});
	}
}
